function resolveFilters(
  filters?: Record<string, string>
): Record<string, string> {
  if (!filters) return {};
  const resolved: Record<string, string> = {};

  for (const k in filters) {
    const v = filters[k];
    if (v) {
      resolved[k] = v;
    }
  }
  return resolved;
}

export { resolveFilters };
